import { CalculatedProductPrice } from "@lib/util/get-product-price"
import { CheckoutExperimentsDefinition } from "@modules/signup-and-order-flow/experiments/experiment-interfaces"

export enum FlowType {
  SIGN_UP = "SIGN_UP",
  LOG_IN = "LOG_IN",
}

export interface SessionData {
  product: {
    productId: string | null
    calculatedPrices: CalculatedProductPrice | null
    preSelectedInstallment?: number
    cartTotal?: number | null
  }

  user: {
    userUuid: string | null
  }

  progress: {
    paymentOptionsCompleted: boolean
    signupCompleted: boolean
    orderPlaced: boolean
    serverErrorOccurred: boolean
    startedSignupFlow: boolean
  }

  flowType: FlowType
  treatments: CheckoutExperimentsDefinition
}

// Action types
export enum SessionActionType {
  UPDATE_PRODUCT = "UPDATE_PRODUCT",
  UPDATE_USER = "UPDATE_USER",
  UPDATE_PROGRESS = "UPDATE_PROGRESS",
  UPDATE_FLOW_TYPE = "UPDATE_FLOW_TYPE",
  RESET_SESSION = "RESET_SESSION",
  SET_SESSION = "SET_SESSION",
}

export type SessionAction =
  | { type: SessionActionType.UPDATE_PRODUCT; payload: Partial<SessionData["product"]> }
  | { type: SessionActionType.UPDATE_USER; payload: Partial<SessionData["user"]> }
  | { type: SessionActionType.UPDATE_PROGRESS; payload: Partial<SessionData["progress"]> }
  | { type: SessionActionType.UPDATE_FLOW_TYPE; payload: FlowType }
  | { type: SessionActionType.RESET_SESSION }
  | { type: SessionActionType.SET_SESSION; payload: SessionData }
